var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideAccordionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35174 5.93771C7.53922 6.12524 7.64453 6.37955 7.64453 6.64471C7.64453 6.90988 7.53922 7.16418 7.35174 7.35171L1.69475 13.0087C1.50614 13.1909 1.25354 13.2917 0.991343 13.2894C0.729147 13.2871 0.478334 13.1819 0.292926 12.9965C0.107518 12.8111 0.0023489 12.5603 7.05719e-05 12.2981C-0.00220776 12.0359 0.0985866 11.7833 0.280745 11.5947L5.23075 6.64471L0.280745 1.69471C0.0985866 1.50611 -0.00220776 1.25351 7.05719e-05 0.99131C0.0023489 0.729113 0.107518 0.478301 0.292926 0.292893C0.478334 0.107485 0.729147 0.00231622 0.991343 3.78026e-05C1.25354 -0.00224062 1.50614 0.0985537 1.69475 0.280712L7.35174 5.93771Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideAccordionArrow);
export default __webpack_public_path__ + "static/media/sideAccordionArrow.6dd0041504e96c948c434ec104dd6456.svg";
export { ForwardRef as ReactComponent };